import { GridSortModel } from '@mui/x-data-grid-pro';
import { useState } from 'react';

interface DefaultTableProps {
  sortModel: GridSortModel
}

export const useTable = ({
  sortModel: defaultSortModel,
}: DefaultTableProps) => {
  const [sortModel, setSortModel] = useState<GridSortModel>(defaultSortModel);

  return {
    sortModel,
    setSortModel
  };
};